import React from "react";
import { motion } from "framer-motion";

const words = ["Passion Fruit", "Orange", "Guava", "Aloha"];

const Ribbon = () => {
  return (
    <section
      data-testid="ribbon-section"
      className="relative bg-[#14100D] border-y border-[#EFE7D6]/10 py-14 md:py-20 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-8 md:px-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 items-center">
          <div className="md:col-span-1">
            <span className="counter">02 — Trilogy</span>
          </div>
          <div className="md:col-span-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="flex flex-wrap items-baseline gap-x-6 md:gap-x-10 font-display text-3xl sm:text-5xl md:text-6xl text-[#EFE7D6] leading-none tracking-tighter"
            >
              {words.map((w, i) => (
                <React.Fragment key={w}>
                  <span className={i === 2 ? "text-[#E85A15]" : ""}>{w}</span>
                  {i < words.length - 1 && (
                    <span className="text-[#DCCFB4]/40 font-body not-italic text-xl">/</span>
                  )}
                </React.Fragment>
              ))}
            </motion.div>
            <div className="mt-6 max-w-2xl font-body text-lg md:text-xl text-[#DCCFB4]/75 leading-relaxed">
              Three fruits. One island. One flavor that never left Hawai‘i's collective memory.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ribbon;
